import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { questionsRUS } from '../components/questionsRUS';
import { questionsENG } from '../components/questionsENG';
import './Main.scss';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { store } from '../store/store';
import Header from '../components/Header';

const Main = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [answers, setAnswers] = useState(() => {
    const saved = localStorage.getItem('quiz_answers');
    return saved ? JSON.parse(saved) : [];
  });
  // const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { language } = useSelector(state => state.user);
  const [errorMessage, setErrorMessage] = useState('');

  const questions = language === 'RUS' ? questionsRUS : questionsENG;

  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    
    if (tg) {
      // Показываем кнопку "Назад" начиная со второго вопроса
      if (currentQuestion > 0) {
        tg.BackButton.show();
      } else {
        tg.BackButton.hide();
      }

      // Обработчик нажатия кнопки "Назад"
      const handleBackClick = () => {
        setCurrentQuestion(prev => prev - 1);
        // Восстанавливаем предыдущий ответ
        const previousAnswer = answers.find(
          a => a.questionId === questions[currentQuestion - 1].id
        );
        if (previousAnswer) {
          if (questions[currentQuestion - 1].type === 'input') {
            setInputValue(previousAnswer.answer);
          } else {
            setSelectedAnswer(previousAnswer.answer);
          }
        }
      };

      tg.BackButton.onClick(handleBackClick);

      // Очистка при размонтировании
      return () => {
        tg.BackButton.offClick(handleBackClick);
        tg.BackButton.hide();
      };
    }
  }, [currentQuestion, answers]); // Зависимости useEffect

  const handleSubmitQuiz = async () => {
    console.log('🔄 Отправляем запрос на сервер');

    try {
      const initData = window.Telegram?.WebApp?.initData;
      if (!initData) {
        throw new Error('No Telegram WebApp initData found');
      }

      const saveResponse = await fetch(`${process.env.REACT_APP_WEBAPP_URL}/api/save-answers`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          initData,
          answers
        })
      });

      console.log('📡 Статус ответа:', saveResponse.status);
      
      const responseData = await saveResponse.json();
      console.log('📦 Данные ответа:', responseData);

      if (responseData.success && responseData.user) {
        console.log('💾 Инициализируем пользователя с данными:', responseData.user);
        
        // Обновляем userData через существующий редьюсер
        dispatch({
          type: 'user/updateUserData',
          payload: responseData.user
        });

        // Проверяем состояние после обновления
        const currentState = store.getState();
        console.log('�� Состояние после обновления:', currentState.user);

        if (currentState.user.userData?.death_date) {
          console.log('✅ Данные сохранены, переходим на /deadline');
          navigate('/deadline');
        } else {
          throw new Error('Данные не сохранились в store');
        }
      } else {
        throw new Error('Некорректный ответ от сервера');
      }

    } catch (error) {
      console.error('❌ Ошибка:', error);
      alert('Произошла ошибка при сохранении ответов');
    }
  };

  const handleAnswerSelect = (optionId) => {
    setSelectedAnswer(optionId);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    
    // Очищаем сообщение об ошибке при любом вводе
    setErrorMessage('');
    
    // Для первого вопроса (имя)
    if (questions[currentQuestion].id === 1) {
        // Проверяем только длину
        if (value.length <= 20) {
            setInputValue(value);
        }
    }
    // Для второго вопроса (возраст)
    else if (questions[currentQuestion].id === 2) {
        // Проверяем, что вводятся только цифры и не более 2 символов
        if (/^\d*$/.test(value) && value.length <= 2) {
            setInputValue(value);
        }
    }
  };

  const handleNext = () => {
    const question = questions[currentQuestion];
    
    if (question.type === 'input') {
        if (!inputValue) return;
        
        // Проверка возраста при переходе
        if (question.id === 2) {
            const age = parseInt(inputValue);
            if (age < 18 || age > 99) {
                setErrorMessage(language === 'RUS' 
                    ? 'Возраст должен быть от 18 до 99 лет' 
                    : 'Age must be between 18 and 99');
                return;
            }
            setErrorMessage(''); // Очищаем сообщение об ошибке если возраст валидный
        }
    }
    if (question.type === 'options' && selectedAnswer === null) return;

    const newAnswer = {
      questionId: question.id,
      answer: question.type === 'input' ? inputValue : selectedAnswer
    };

    const existingAnswerIndex = answers.findIndex(a => a.questionId === question.id);
    
    const newAnswers = [...answers];
    
    if (existingAnswerIndex !== -1) {
      newAnswers[existingAnswerIndex] = newAnswer;
    } else {
      newAnswers.push(newAnswer);
    }
    
    setAnswers(newAnswers);
    localStorage.setItem('quiz_answers', JSON.stringify(newAnswers));

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(prev => prev + 1);
      setSelectedAnswer(null);
      setInputValue('');
    } else {
      handleSubmitQuiz();
      // navigate('/deadline');
    }
  };

  const renderQuestion = () => {
    const question = questions[currentQuestion];

    if (question.type === 'input') {
        return (
            <>
                <input
                    type={question.id === 2 ? "number" : "text"}
                    value={inputValue}
                    onChange={handleInputChange}
                    placeholder={question.placeholder}
                    className="input-field"
                    maxLength={question.id === 1 ? 20 : 2}
                    pattern={question.id === 2 ? "[0-9]*" : undefined}
                />
                {errorMessage && question.id === 2 && (
                    <small style={{ color: '#ff4d4d', marginTop: '5px' }}>
                        {errorMessage}
                    </small>
                )}
            </>
        );
    }

    return (
      <div className="options">
        {question.options.map((option) => (
          <motion.button
            key={option.id}
            whileTap={{ scale: 0.95 }}
            className={`option ${selectedAnswer === option.id ? 'selected' : ''}`}
            onClick={() => handleAnswerSelect(option.id)}
          >
            <div></div>
            {option.text}
          </motion.button>
        ))}
      </div>
    );
  };

  const isPC = () => {
    return !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  };

  return (
    <div className="quiz-container">
      <Header className="main-header" hearts={localStorage.getItem('quiz_answers') && JSON.parse(localStorage.getItem('quiz_answers')).length}/>
      <AnimatePresence mode="wait">
        <motion.div
          key={currentQuestion}
          initial={{ x: 300, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: -300, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className={`question-card ${isPC() && 'question-card-desctop'}`}
        >
          <div className="question-card-content">
            <h2>{questions[currentQuestion].question}</h2>
            
            {questions[currentQuestion].rate && (
              <span className="info-icon" onClick={() => setShowModal(true)}>
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="12" 
                  height="12" 
                  viewBox="0 0 12 12" 
                  fill="none"
                  style={{ marginTop: '20px', verticalAlign: 'middle', position: 'absolute' }}
                >
                  <path d="M5.306 8.554V4.046H6.23V8.554H5.306ZM5.768 3.402C5.58133 3.402 5.44133 3.35533 5.348 3.262C5.25467 3.16867 5.208 3.03333 5.208 2.856C5.208 2.66933 5.25467 2.534 5.348 2.45C5.44133 2.35667 5.58133 2.31 5.768 2.31C5.91733 2.31 6.04333 2.35667 6.146 2.45C6.258 2.534 6.314 2.66933 6.314 2.856C6.314 3.04267 6.258 3.18267 6.146 3.276C6.04333 3.36 5.91733 3.402 5.768 3.402ZM5.768 11.536C4.97467 11.536 4.228 11.3867 3.528 11.088C2.828 10.7893 2.212 10.3787 1.68 9.856C1.15733 9.324 0.746667 8.708 0.448 8.008C0.149333 7.308 0 6.56133 0 5.768C0 4.96533 0.149333 4.21867 0.448 3.528C0.746667 2.828 1.15733 2.21667 1.68 1.694C2.212 1.162 2.828 0.746667 3.528 0.448C4.228 0.149333 4.97467 0 5.768 0C6.57067 0 7.31733 0.149333 8.008 0.448C8.708 0.746667 9.31933 1.162 9.842 1.694C10.374 2.21667 10.7893 2.828 11.088 3.528C11.3867 4.21867 11.536 4.96533 11.536 5.768C11.536 6.56133 11.3867 7.308 11.088 8.008C10.7893 8.708 10.374 9.324 9.842 9.856C9.31933 10.3787 8.708 10.7893 8.008 11.088C7.31733 11.3867 6.57067 11.536 5.768 11.536ZM5.768 10.752C6.45867 10.752 7.10267 10.626 7.7 10.374C8.30667 10.1127 8.83867 9.75333 9.296 9.296C9.75333 8.83867 10.108 8.31133 10.36 7.714C10.6213 7.10733 10.752 6.45867 10.752 5.768C10.752 5.07733 10.6213 4.43333 10.36 3.836C10.108 3.22933 9.75333 2.69733 9.296 2.24C8.83867 1.78267 8.30667 1.428 7.7 1.176C7.10267 0.914666 6.45867 0.784 5.768 0.784C5.07733 0.784 4.42867 0.914666 3.822 1.176C3.22467 1.428 2.69733 1.78267 2.24 2.24C1.78267 2.69733 1.42333 3.22933 1.162 3.836C0.91 4.43333 0.784 5.07733 0.784 5.768C0.784 6.45867 0.91 7.10733 1.162 7.714C1.42333 8.31133 1.78267 8.83867 2.24 9.296C2.69733 9.75333 3.22467 10.1127 3.822 10.374C4.42867 10.626 5.07733 10.752 5.768 10.752Z" fill="#8F9098"/>
                </svg>
                <span>
                  {'\u00A0'}{'\u00A0'}{'\u00A0'}{'\u00A0'}{'\u00A0'}{questions[currentQuestion].description}...
                  {language === 'RUS' ? 'Подробнее' : 'More'}
                </span>
              </span>
            )}
            {renderQuestion()}
          </div>

        </motion.div>
      </AnimatePresence>

      <div className="buttons-container">
        {currentQuestion > 0 && (
          <button
            className="back-button"
            onClick={() => {
              setCurrentQuestion(prev => prev - 1);
              // Восстанавливаем предыдущий ответ
              const previousAnswer = answers.find(
                a => a.questionId === questions[currentQuestion - 1].id
              );
              if (previousAnswer) {
                if (questions[currentQuestion - 1].type === 'input') {
                  setInputValue(previousAnswer.answer);
                } else {
                  setSelectedAnswer(previousAnswer.answer);
                }
              }
            }}
          >
            {language === 'RUS' ? `<- Назад` : `<- Back`}
          </button>
        )}
        <button
          className={`next-button ${!selectedAnswer && !inputValue ? 'disabled' : ''} ${
            currentQuestion === 0 ? 'fullWidth' : ''
          }`}
          onClick={handleNext}
          disabled={!selectedAnswer && !inputValue}
        >
          {currentQuestion === questions.length - 1 ? language === 'RUS' ? 'Завершить' : 'Finish' : language === 'RUS' ? 'Далее ->' : 'Next ->'}
        </button>
      </div>

      {showModal && questions[currentQuestion].rate && (
        <motion.div 
          className="modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={(e) => {
            if (!e.target.closest('.modal')) {
              setShowModal(false);
            }
          }}
        >
          <motion.div 
            className="modal"
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
          >
            <button 
              className="close-button"
              onClick={() => setShowModal(false)}
            >
              ✕
            </button>

            <h1>{language === 'RUS' ? 'Оценка влияния' : 'Impact Assessment'}</h1>
            
            <div className="progress-bar-container">
              <div className="progress-bar">
                <div 
                  className="progress-marker"
                  style={{ left: `${questions[currentQuestion].rate}%` }}
                  data-rate={questions[currentQuestion].rate}
                />
              </div>
            </div>

            <p className="impact-text">
              {questions[currentQuestion].impact}
            </p>

            <a 
              href={questions[currentQuestion].link} 
              target="_blank" 
              rel="noopener noreferrer"
              className="source-link"
            >
              {language === 'RUS' ? 'Узнать больше' : 'Learn more'}
            </a>
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};

export default Main;
